import { Heart } from 'lucide-react'

const HoneymoonFund = () => {
  return (
    <section className="section-padding bg-sage-light">
      <div className="container-max">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg">
              <Heart className="w-10 h-10 text-sage" />
            </div>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-4">
            Honeymoon Fund
          </h2>
        </div>

        {/* Main Content */}
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-lg text-charcoal/80 mb-8 leading-relaxed">
            As we celebrate our new life together no gifts are expected, but if you insist, it would be so kind if you want to help us celebrate our honeymoon adventures instead! There will be a card box at the reception or you can also bless us through Venmo, Cash App or PayPal.
          </p>

          {/* Payment Methods */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {/* Venmo */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="text-blue-600 font-bold text-xl">V</div>
              </div>
              <h3 className="font-semibold text-lg text-charcoal mb-2">Venmo</h3>
              <p className="text-charcoal/70 text-sm">@enewman202</p>
            </div>

            {/* Cash App */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="text-green-600 font-bold text-xl">$</div>
              </div>
              <h3 className="font-semibold text-lg text-charcoal mb-2">Cash App</h3>
              <p className="text-charcoal/70 text-sm">$AFSFLithia</p>
            </div>

            {/* PayPal */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="text-blue-600 font-bold text-xl">P</div>
              </div>
              <h3 className="font-semibold text-lg text-charcoal mb-2">PayPal</h3>
              <p className="text-charcoal/70 text-sm">dmweinberger@gmail.com</p>
            </div>
          </div>

          {/* Thank You Message */}
          <div className="bg-white/50 rounded-2xl p-6 mt-8">
            <p className="text-charcoal/70 italic">
              "Your presence at our wedding is the greatest gift of all. Thank you for being part of our special day and for helping us start our new chapter together."
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HoneymoonFund
